// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import User from "./user.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "expanded": {
      "column": {
        "default": "0",
        "name": "expanded",
        "null": false,
        "type": "boolean"
      },
      "name": "expanded",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "identifier": {
      "column": {
        "default": null,
        "name": "identifier",
        "null": true,
        "type": "string"
      },
      "name": "identifier",
      "selected_by_default": null,
      "translated": null
    },
    "resource_id": {
      "column": {
        "default": null,
        "name": "resource_id",
        "null": false,
        "type": "string"
      },
      "name": "resource_id",
      "selected_by_default": null,
      "translated": null
    },
    "resource_type": {
      "column": {
        "default": null,
        "name": "resource_type",
        "null": false,
        "type": "string"
      },
      "name": "resource_type",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    },
    "user_id": {
      "column": {
        "default": null,
        "name": "user_id",
        "null": false,
        "type": null
      },
      "name": "user_id",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "ClassStatusExpansion",
  "collectionKey": "class_status_expansions",
  "collectionName": "class_status_expansions",
  "i18nKey": "class_status_expansion",
  "camelizedLower": "classStatusExpansion",
  "name": "ClassStatusExpansion",
  "nameDasherized": "class-status-expansion",
  "pluralName": "class_status_expansions",
  "ransackable_associations": [
    {
      "className": "ClassStatusExpansion::Audit",
      "collectionName": "class_status_expansion_audits",
      "foreignKey": "class_status_expansion_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "ClassStatusExpansionAudit",
      "through": null
    },
    {
      "className": "ClassStatusExpansion::Audit",
      "collectionName": "class_status_expansion_audits",
      "foreignKey": "class_status_expansion_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "ClassStatusExpansionAudit",
      "through": null
    },
    {
      "className": "Resource",
      "collectionName": null,
      "foreignKey": "resource_id",
      "name": "resource",
      "macro": "belongs_to",
      "resource_name": null,
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "user_id",
      "name": "user",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "expanded",
      "column": {
        "default": "0",
        "name": "expanded",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "identifier",
      "column": {
        "default": null,
        "name": "identifier",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "resource_id",
      "column": {
        "default": null,
        "name": "resource_id",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "resource_type",
      "column": {
        "default": null,
        "name": "resource_type",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "user_id",
      "column": {
        "default": null,
        "name": "user_id",
        "null": false,
        "type": null
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "user_id",
      "name": "user",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    }
  ],
  "paramKey": "class_status_expansion",
  "primaryKey": "id"
}

/** Frontend model for ClassStatusExpansion. */
export default class ClassStatusExpansion extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  expanded() {
    return this.readAttributeUnderscore("expanded")
  }

  /** @returns {boolean} */
  hasExpanded() {
    const value = this.expanded()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  identifier() {
    return this.readAttributeUnderscore("identifier")
  }

  /** @returns {boolean} */
  hasIdentifier() {
    const value = this.identifier()

    return this._isPresent(value)
  }

  /** @returns {string} */
  resourceId() {
    return this.readAttributeUnderscore("resource_id")
  }

  /** @returns {boolean} */
  hasResourceId() {
    const value = this.resourceId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  resourceType() {
    return this.readAttributeUnderscore("resource_type")
  }

  /** @returns {boolean} */
  hasResourceType() {
    const value = this.resourceType()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  userId() {
    return this.readAttributeUnderscore("user_id")
  }

  /** @returns {boolean} */
  hasUserId() {
    const value = this.userId()

    return this._isPresent(value)
  }

  /** @returns {import("./user.js").default | null} */
  user() {
    return this._readBelongsToReflection({modelClass: User, reflectionName: "user"})
  }

  /** @returns {Promise<import("./user.js").default | null>} */
  loadUser() {
    if (!("userId" in this)) throw new Error("Foreign key method wasn't defined: userId")

    const id = this.userId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "user",
        model: this,
        modelClass: User
      },
      {ransack}
    )
  }
}
